import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const setAdminRole = async (userId, value) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/role/" + userId + "/" + value, { headers: AuthHeader.authHeader() });
    return response.data;
};

const setEmailPrefs = async (value) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/email/prefs", 
  { "prefs" : value }, 
  { headers: AuthHeader.authHeader()});
  return response.data;
};

const updateAddress = async (newAddress) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/address/" + newAddress.id, 
    newAddress,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}    

const updateName = async (newName) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/name", 
    newName,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}    

const updateUsernameEmail = async (newName) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/username", 
    newName,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}    

const updateBillingAddress = async (newAddress) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/billingaddress", 
    newAddress,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}    

const forgotPassword = async (emailAddress) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/forgotpassword", 
    {emailAddress: emailAddress},
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}    

const resetPassword = async (emailAddress, newPassword, confirmPassword, forgotId) => {
  console.log("resetPassword", emailAddress, newPassword, confirmPassword, forgotId);
  try {
    const response = await axios.post(process.env.REACT_APP_API_URL + "/user/resetpassword", 
      {
        emailAddress: emailAddress,
        newPassword: newPassword,
        confirmNewPassword: confirmPassword,
        forgotId: forgotId
      },
      { headers: AuthHeader.authHeader() }
    );
    return response.data;
  } catch(err) {
    console.log(err);
    return err.response.data;
  }
}    

const sendUnregisteredEmailToAll = async (userId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/email/unregistered", { headers: AuthHeader.authHeader() });
    return response.data;
};

const sendUnregisteredEmail = async (userId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/email/unregistered/" + userId, { headers: AuthHeader.authHeader() });
    return response.data;
};

const deactivateUser = async (userId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/deactivate/" + userId, { headers: AuthHeader.authHeader() });
    if(response.error) {
      return response;
    }
    return response.data;
};

const reactivateUser = async (userId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/user/reactivate/" + userId, { headers: AuthHeader.authHeader() });
    if(response.error) {
      return response;
    }
    return response.data;
};

const submitContactUs = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/contactus", 
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};
const updateUserBalances = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/bulk", 
    {users: data},
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const getAddresses = async () => {
  const response = await axios.get(process.env.REACT_APP_API_URL + "/user/addresses", 
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const addAddress = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/user/address", 
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const removeAddress = async (addressId) => {
  const response = await axios.delete(process.env.REACT_APP_API_URL + "/user/address/" + addressId, 
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const setOrderAddress = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/order/address",
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const updateBalanceRollsOver = async (data) => {
  const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/user/balanceRollsOver", 
    data,
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
}

const UserService = {
  setAdminRole,
  setEmailPrefs,
  updateAddress,
  updateBillingAddress,
  forgotPassword,
  resetPassword,
  sendUnregisteredEmail,
  sendUnregisteredEmailToAll,
  deactivateUser,
  reactivateUser,
  submitContactUs,
  updateName,
  updateUserBalances,
  updateUsernameEmail,
  getAddresses,
  addAddress,
  removeAddress,
  updateBalanceRollsOver

};

export default UserService;